export const config = {
  apiBase: "https://app.accountintime.tn ",
  tenantId: "demo",
  userId: "user1",
};
